import { FC } from 'react';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';
import QuestionnaireContent from './QuestionnaireContent';

const QuestionnaireScene: FC = () => (
  <LoanApplicationProcessLayout>
    <QuestionnaireContent />
  </LoanApplicationProcessLayout>
);

export default QuestionnaireScene;
